import axios from "axios";
import "element-ui/lib/theme-chalk/index.css";
import { Loading, Message, MessageBox } from "element-ui";
import store from '@/store'
import { getToken, getTokenTime, h2ms, setTokenTime } from "./auth";
import { tokenTimeout } from "../setting";


const whiteList = ['/login', '/sendAuthCode', '/goSetPasswordPage', '/setNewPassword']; // 不用校验token
class HttpRequest {
  constructor() {
	    // this.baseUrl="https://www.gaojidata.com/rank-sso"  // 正式平台服务
	  // this.baseUrl="https://product-3f3ab907.gaojidata.com/rank-sso"  // 测试平台服务
	  this.baseUrl = process.env.VUE_APP_API_BASE || "/api"  // 测试平台服务
	  // this.baseUrl ="http://192.168.1.236"
	  // 线下236服务地址

	  //this.baseUrl ="http://192.168.1.249/"    //   process.env.NODE_ENV === "development"
	  //     // ? "http://192.168.1.208:8099/rank-sso/"
	  //     // ? "http://192.168.1.49/"
	  //     ? "http://192.168.1.236/"
	  //     : "/rank-sso";
    this.timeout = 5000;
    this.queue = {};
    this.loadingInstance = null;
  }
  mergeOptions(options) {
    return {
			timeout: this.timeout,
      baseURL: this.baseUrl,
      headers: {},
      ...options,
    };
  }
  destory(url) {
    delete this.queue[url];
    // if(!Object.keys(this.queue).length) {}
  }
  interceptors(instance, {url}) {
    instance.interceptors.request.use(config => {
			if(getTokenTime()) {
				let dateNow = Date.now();
				if((getTokenTime - dateNow) >= h2ms(tokenTimeout)) {
					Message({
						message: '登录失效,即将跳转登录页',
						type: 'error',
						duration: 3 * 1000
					})
					setTimeout(() => {
						store.dispatch('user/resetToken').then(() => {
							location.reload()
						})
					}, 3000)
					return false;
				} else {
					setTokenTime(dateNow);
				}
			}
        // 此处可添加全局loading
			this.loadingInstance = Loading.service({
				fullscreen: true,
				text: "Loading...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.1)",
			});
			let authorization = "";
			const token = getToken();
			if(token) {
				// authorization = authorization + token
				authorization =  token
			}
			if (whiteList.indexOf(url) < 0) { //url != "login"
				config.headers.Authorization = authorization;
			}
			this.queue[url] = true;
			return config;
		}, error => {
			console.log(error);
			return Promise.reject(error);
		});
    instance.interceptors.response.use( response => {
			this.destory(url);
			this.loadingInstance.close(); //关闭loading
			const res = response.data;
			if (res.code != 200) {
				if(url == '/sendSmsAuthCode' && location.hash == '#/login'){

				} else {
					Message({
						message: res.message || 'Error',
						type: 'error',
						duration: 3 * 1000
					})
				}

				// 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
				if (res.code == 403 || res.code == 409 ) {
					// to re-login
					// MessageBox.confirm('您的登录信息已过期，您可以取消停留在此页面上，或者重新登录', '确认重新登录', {
					// 	confirmButtonText: '重新登陆',
					// 	cancelButtonText: '取消',
					// 	type: 'warning'
					// }).then(() => {
					// 	store.dispatch('user/resetToken').then(() => {
					// 		location.reload()
					// 	})
					// })
					store.dispatch('user/resetToken').then(() => {
						location.reload()
					})
				}
				return Promise.reject(new Error(res.message || 'Error'))
			} else {
				return Promise.resolve(res)
			}
			// if ( whiteList.indexOf(url) < 0) {
			// 	// store.commit('setToken', '');  // 清空token
			// 	if (res.data.code != 201) {	Message.error(res.data.message); }
			// 	if (location.href != `${location.origin}/#/login`) { location.href = `${location.origin}/#/login`;}
			// 	const { data, status } = res;
			// 	return { data, status };
			// }
		}, error  => {
			// 请求失败
			this.destory(url);
			// let errorInfo = error.response;
			// console.log(errorInfo);
			// if (!errorInfo) {
			// 	const { request: { statusText, status }, 	config, } = JSON.parse(JSON.stringify(error));
			// 	errorInfo = {
			// 		statusText,
			// 		status,
			// 		request: { responseURL: config.url },
			// 	};
			// }
			this.loadingInstance.close();
			Message({
				message: '请求失败',
				type: 'error',
				duration: 3 * 1000
			})

			//addErrorLog(errorInfo)
			return Promise.reject(error);
		});
  }

  request(options) {
    const instance = axios.create();
    options = this.mergeOptions(options);
		this.interceptors(instance, options)
    return instance(options);
  }

  get(params) {
    return this.request({
      ...params,
      method: "get",
    });
  }

  post(params) {
    return this.request({
      ...params,
      method: "post",
    });
  }
}
const request = new HttpRequest();
export default request;


